import { render, staticRenderFns } from "./EmailPopup.vue?vue&type=template&id=1611c2d9&scoped=true&"
import script from "./EmailPopup.vue?vue&type=script&lang=js&"
export * from "./EmailPopup.vue?vue&type=script&lang=js&"
import style0 from "./EmailPopup.vue?vue&type=style&index=0&id=1611c2d9&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1611c2d9",
  null
  
)

export default component.exports